import addressManagement from "../address-management/rbmc.address-management";

const addressErrors = {

    handleOnError(elementNamesObject){
        $.each(elementNamesObject, function(index, element){
            addressManagement.addressForm
                .find(`[name=${element.fieldName}]`)
                .parents('.custom-form')
                .addClass('custom-form--invalid');
            if( element.fieldName == 'countryIso') {
                addressManagement.addressForm
                    .find(`[name=${element.fieldName}]`)
                    .parent().parent().append(addressErrors.errorLabelTemplate(
                        element.errorMessage));
            } else {
                addressManagement.addressForm
                    .find(`[name=${element.fieldName}]`)
                    .parent().append(addressErrors.errorLabelTemplate(
                        element.errorMessage));
            }
        });
    },

    removeErrors(){
        addressManagement.addressForm.find('.custom-form--invalid').each(function (i, el) {
            $(el).removeClass('custom-form--invalid');
        });
        addressManagement.addressForm.find('.custom-form__label--invalid').remove();
    },

    errorLabelTemplate(messageText){
        return `<label class="custom-form__label--invalid">
                    <span>${messageText}</span>
                </label>`;
    }
};

export default addressErrors;
